module.exports = "/assets/site/images/full_size.png?fc5a1fcaf6ef3b9284aaeaed23b4d29d";